import { render, staticRenderFns } from "./Heremap.vue?vue&type=template&id=906c0228&scoped=true&"
import script from "./Heremap.vue?vue&type=script&lang=js&"
export * from "./Heremap.vue?vue&type=script&lang=js&"
import style0 from "./Heremap.vue?vue&type=style&index=0&id=906c0228&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906c0228",
  null
  
)

export default component.exports